import React from 'react';
import PropTypes from 'prop-types';

import 'assets/scss/banner.css';
import { getPlanSubscriptionStatus } from '../../constants/localStorageManager';
import { formatExpiryDate } from '../../utils/date';

const RenewPlanBanner = ({ isVisible, toggleBanner, renewPlan }) => {
  if (!isVisible) return null;
  const { end_date } = getPlanSubscriptionStatus() || {};
  const expiryDate = formatExpiryDate(end_date);

  return (
    <div className="renew-banner">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <a
              role="button"
              onClick={e => {
                e.preventDefault();
                toggleBanner();
              }}
              className="cursor-pointer close-onboarding-modal float-right"
            >
              X
            </a>
            <div className="row d-flex flex-column align-items-center">
              <h5 className="pt-3 ml-3 sub-text text-center">
                Hey, there! your subscription to soono has ended on {expiryDate}.
                <small className="d-block pt-3">
                  Want to be able to manage Surveys and view complete Reports?
                  Renew your subscription.
                </small>
              </h5>
              <div>
                <button
                  type="button"
                  className="btn ml-4 my-4"
                  onClick={renewPlan}
                >
                  Renew Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RenewPlanBanner.defaultProps = {
  isVisible: false,
  renewPlan: () => {},
};

RenewPlanBanner.propTypes = {
  isVisible: PropTypes.bool,
  renewPlan: PropTypes.func,
};

export default RenewPlanBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/RenewPlanBanner.js